var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTelegramColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_telegram-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD365",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC023",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1267.000000, -48.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1147.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_telegram-color",
    transform: "translate(120.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C34.1502648,0 44,9.84973517 44,22 C44,34.1502648 34.1502648,44 22,44 C9.84973517,44 0,34.1502648 0,22 C0,9.84973517 9.84973517,0 22,0 Z M32.2647569,11.0509204 C31.7846831,11.0499139 31.1394791,11.2681441 31.043918,11.3025844 L31.0318922,11.3071322 L7.69284694,20.5788092 C7.69284694,20.5788092 6.67129833,20.9050936 6.67129833,21.5894097 C6.67129833,22.3592665 7.54412255,22.6595097 7.65322558,22.6940329 L7.66437833,22.697455 L13.2429306,24.1810556 L13.248,24.184 L27.6891389,15.54333 C27.9032559,15.3807962 28.1969617,15.3973429 28.3895445,15.5722033 L28.4566639,15.6451564 C28.6395144,15.886035 28.5946222,16.22874 28.3537436,16.4115906 L28.3537436,16.4115906 L17.589,26.369 L20.9050936,29.1223717 L26.4737917,33.7439758 C26.4737917,33.7439758 26.7989792,34.0439794 27.4296458,34.0439794 C28.5540571,34.0439794 28.7714502,33.1851119 28.791219,33.0947048 L28.7928056,33.0870314 L32.8943267,12.1458333 C32.8943267,12.1458333 32.9490731,11.8721044 32.9490731,11.5983786 C32.9490731,11.1877883 32.5844689,11.0509204 32.2647569,11.0509204 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegramColor);
export default __webpack_public_path__ + "static/media/ic_telegram-color.84b95271f62e3198c1921e171430f8a7.svg";
export { ForwardRef as ReactComponent };